import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-white/95 backdrop-blur-md border-t border-border/50 mt-auto">
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col items-center gap-4 text-center">
          {/* Logo and Brand */}
          <div className="flex items-center gap-2">
            <img src="/logo.svg" alt={t('footer.logo')} className="h-6 w-6" />
            <span className="text-lg font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Lingua Craft
            </span>
          </div>

          {/* Developer Credit */}
          <div className="text-sm text-muted-foreground">
            <p>
              {t('footer.developedBy')}{' '}
              <a
                href="https://hoangpham.dev"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-primary hover:text-primary/80 transition-colors"
              >
                Hoang Pham
              </a>
            </p>
          </div>

          {/* Copyright */}
          {/* <div className="text-xs text-muted-foreground/70">
            <p>&copy; {new Date().getFullYear()} Lingua Craft. {t('footer.allRightsReserved')}.</p>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
